import { LoginPage } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/login'].update({
        staticData: { title: { page: 'Pages.Login.Header' } },
        component: LoginPage
    });
};
